import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Modal, Form, Spinner } from "react-bootstrap";
import * as confirmModal from "../../redux/confirmModalRedux";
import CustomBlock from './CustomBlock';
import ModalBlock from './ModalBlock';
import Button from './Button';

const ConfirmModal = (props) => {
    const { showConfirmModal, hideConfirmModal, confirmModal, setProcessing } = props;

    const handleCloseBtn = () => {
        hideConfirmModal();
        if (confirmModal.closeBtnAction)
            confirmModal.closeBtnAction();
    }

    return (
        <ModalBlock
            centered
            size="md"
            show={confirmModal.isVisible}
            onHide={handleCloseBtn}
            closeAction
            closeActionOnClick={handleCloseBtn}
            contentHeader={confirmModal.title}
            centered
            padded
            static
            contentDescription={confirmModal.text}
            contentDescriptionClassName="ml-0"
        >
            <CustomBlock className="content-container--actions pr-0">
                <Button
                    text="Cancel"
                    className="grey--bg"
                    onClick={handleCloseBtn}
                    disabled={confirmModal.isProcessing}
                />

                <Button
                    text={confirmModal.rightBtnText}
                    className="primary--bg mr-0"
                    loading={confirmModal.isProcessing}
                    disabled={confirmModal.isProcessing}
                    onClick={setProcessing, confirmModal.btnAction}
                />
            </CustomBlock>
        </ModalBlock>
    )
}

const mapStateFromProps = (state) => ({
    confirmModal: state.confirmModal
})

export default connect(mapStateFromProps, confirmModal.actions)(ConfirmModal)